'use client'

import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

type CenteredDialogProps = {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
}

export function CenteredDialog({ isOpen, onClose, children }: CenteredDialogProps) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!isOpen || !mounted) return null

  return createPortal(
    <>
      {/* Invisible backdrop for click-to-close */}
      <div
        className="fixed inset-0 z-[150]"
        onClick={onClose}
      />

      {/* Centered Dialog */}
      <div className="fixed inset-0 z-[151] flex items-center justify-center px-[16px] pointer-events-none">
        <div className="bg-[#F7F1E7] rounded-[8px] max-w-[500px] w-full pointer-events-auto border-2 border-black">
          {children}
        </div>
      </div>
    </>,
    document.body
  )
}
